// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/message-square-plus.js';

import { paths } from '../generated/message-square-plus';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('message-square-plus', Original, paths);
